import React from 'react';
import { Text } from '@usealloy/component-library';
import type { TemplateAtoms } from '../types';

const commonStyleProps: React.CSSProperties = {
  fontSize: 'var(--cl-font-size-2)',
  lineHeight: 'normal',
};

const prettifiedAtoms: TemplateAtoms<React.FC> = {
  heading1: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-gray-1100)',
        fontWeight: 700,
        marginTop: 'var(--cl-space-2)',
      }}
    >{content}
    </Text>
  ),
  heading2: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-gray-700)',
        fontWeight: 400,
        marginTop: 'var(--cl-space-1-5)',
      }}
    >{content}
    </Text>
  ),
  heading3: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-gray-1100)',
        fontWeight: 400,
        marginTop: 'var(--cl-space-1)',
      }}
    >{content}
    </Text>
  ),
  bulletPoint: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-gray-1100)',
        fontWeight: 400,
        marginTop: 'var(--cl-space-1)',
      }}
    >•{' '}{content}
    </Text>
  ),
  text: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-gray-1100)',
        fontWeight: 400,
        marginTop: 'var(--cl-space-1)',
        fontFamily: 'var(--cl-font-family-mono)',
      }}
    >{content}
    </Text>
  ),
  bold: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-gray-700)',
        fontWeight: 400,
        marginTop: 'var(--cl-space-1)',
      }}
    >{content}
    </Text>
  ),
  error: content => () => (
    <Text
      style={{
        ...commonStyleProps,
        color: 'var(--cl-red-500)',
        fontWeight: 400,
        marginTop: 'var(--cl-space-1)',
      }}
    >{content}
    </Text>
  ),
  emptyLine: () => () => <div style={{ height: 16, width: '100%' }} />,
  emptyLineSmall: () => () => <div style={{ height: 8, width: '100%' }} />,
};


export default prettifiedAtoms;
